import { useCallback } from 'react';
import { useMemo } from 'react';
import { Setter } from 'libs/end-to-end/src/ui-types';
import { SetterWithReducer } from 'libs/end-to-end/src/ui-types';

export const useBasicCopilotApplicableRoles = ({
  deptToRolesMap,
  setSelectedRoles,
  selectedDepartments,
  setSelectedDepartments,
}: {
  deptToRolesMap: Record<string, string[]>;
  selectedDepartments: string[];
  setSelectedDepartments: Setter<string[]>;
  setSelectedRoles: SetterWithReducer<string[]>;
}) => {
  const getApplicableRoles = useCallback(
    (selectedDepartments: string[]) => {
      return [
        ...new Set(
          selectedDepartments.flatMap((dept) => {
            return deptToRolesMap[dept] ?? [];
          }),
        ),
      ];
    },
    [deptToRolesMap],
  );

  const setSelectedDepartmentsWithRoles = useCallback(
    (departments: string[]) => {
      const applicableRoles = getApplicableRoles(departments);
      setSelectedDepartments(departments);
      setSelectedRoles((current) => {
        return current.filter((role) => applicableRoles.includes(role));
      });
    },
    [getApplicableRoles, setSelectedDepartments, setSelectedRoles],
  );

  const applicableRoles = useMemo(() => {
    return getApplicableRoles(selectedDepartments);
  }, [getApplicableRoles, selectedDepartments]);

  return {
    currentApplicableRoles: applicableRoles,
    setSelectedDepartmentsWithRoles,
  };
};
